import React, { useState } from "react";
import { GlassCard, PageTitle, LuxuryButton } from "@/components/lux";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ShieldCheck, Lock, Smartphone } from "lucide-react";

const inp = "w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-white outline-none focus:border-[var(--gold)]/50";

export default function Security() {
  const { logout } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const upd = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password !== f.confirm) return toast.error("Passwords do not match");
    setBusy(true);
    try {
      await api.post("/user/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password changed. Please sign in again.");
      await logout(); nav("/login");
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="space-y-6">
      <PageTitle title="Security" subtitle="Protect your account" />
      <div className="grid gap-6 lg:grid-cols-2">
        <GlassCard className="p-6">
          <div className="mb-4 flex items-center gap-2"><Lock size={18} className="text-[var(--gold)]" /><h3 className="font-semibold text-white">Change Password</h3></div>
          <form onSubmit={submit} className="space-y-3">
            <input className={inp} type="password" placeholder="Current password" value={f.current_password} onChange={upd("current_password")} data-testid="sec-current" required />
            <input className={inp} type="password" placeholder="New password" value={f.new_password} onChange={upd("new_password")} data-testid="sec-new" required />
            <input className={inp} type="password" placeholder="Confirm new password" value={f.confirm} onChange={upd("confirm")} data-testid="sec-confirm" required />
            <LuxuryButton type="submit" disabled={busy} data-testid="sec-submit">Update Password</LuxuryButton>
          </form>
        </GlassCard>
        <GlassCard className="p-6">
          <div className="mb-4 flex items-center gap-2"><Smartphone size={18} className="text-[var(--gold)]" /><h3 className="font-semibold text-white">Two-Factor Authentication</h3></div>
          <div className="flex items-start gap-3 rounded-xl glass-2 p-4">
            <ShieldCheck size={18} className="mt-0.5 text-[var(--gold)]" />
            <div>
              <p className="text-sm text-white">2FA-ready architecture</p>
              <p className="mt-1 text-xs text-[var(--text-dim)]">Two-factor authentication support is built into the platform architecture and can be enabled by the operator. Contact support to activate.</p>
            </div>
          </div>
          <LuxuryButton variant="dark" className="mt-4 opacity-60" disabled data-testid="sec-2fa">Enable 2FA (operator setup required)</LuxuryButton>
        </GlassCard>
      </div>
    </div>
  );
}
